import {createContext} from "react";

const checkoutContext = createContext();

export default checkoutContext;
